module.exports = __webpack_public_path__ + "static/media/Save25Banner.b1b86bd3.png";